<template>
  <div class="mobile">
    <div class="container" v-if="isTheme">
      <div class="section0">
        <swiper :changeNav="changeNav"></swiper>
      </div>
    </div>
    <div class="container" v-if="isTheme==false">
      <div class="section1">
        <div class="nav">
          <div class="item" v-if="navIndex!=0">
            <img
              alt="xxx"
              src="../../assets/classroom/imgsMobile/101.png"
              style="width: 100%;"
              @click="changeNav(0)"
            />
          </div>
          <div class="item" v-if="navIndex==0">
            <img
              alt="xxx"
              src="https://www.csvw.com/u/cms/www/202008/161806286x76.png"
              style="width: 100%;"
              @click="changeNav(0)"
            />
          </div>
          <div class="item" v-if="navIndex!=1">
            <img
              alt="xxx"
              src="../../assets/classroom/imgsMobile/104.png"
              style="width: 100%;"
              @click="changeNav(1)"
            />
          </div>
          <div class="item" v-if="navIndex==1">
            <img
              alt="xxx"
              src="https://www.csvw.com/u/cms/www/202008/16180645754r.png"
              style="width: 100%;"
              @click="changeNav(1)"
            />
          </div>
          <div class="item" v-if="navIndex!=2">
            <img
              alt="xxx"
              src="../../assets/classroom/imgsMobile/105.png"
              style="width: 100%;"
              @click="changeNav(2)"
            />
          </div>
          <div class="item" v-if="navIndex==2">
            <img
              alt="xxx"
              src="https://www.csvw.com/u/cms/www/202008/16180701F45A.png"
              style="width: 100%;"
              @click="changeNav(2)"
            />
          </div>
        </div>
      </div>
      <div class="section2">
        <div class="contain">
          <div class="block clickStyle" v-for="(item ,i) in menu" :key="i">
            <div class="sub-menu" :id="setSubMenuClass(i)" @click="changeMenuIndex(i)">
              <div class="wrap">
                <div class="icon">
                  <div v-if="menuIndex==i">
                    <img alt="xxx" :src="item.iconSelect" />
                  </div>
                  <div v-if="menuIndex!=i">
                    <img alt="xxx" :src="item.iconUrl" />
                  </div>
                </div>
                <div class="middle text" :id="setSubMenuId(i)">{{item.text}}</div>
                <div class="arrow">
                  <div v-if="menuIndex==i&&menuFlag">
                    <img alt="xxx" src="../../assets/imgs/up-white.png" />
                  </div>
                  <div v-if="menuIndex==i&&!menuFlag">
                    <img alt="xxx" src="../../assets/imgs/down-white.png" />
                  </div>
                  <div v-if="menuIndex!=i">
                    <img alt="xxx" src="../../assets/imgs/down-black.png" />
                  </div>
                </div>
                <div style="clear: both;"></div>
              </div>
            </div>
            <template v-if="menuIndex==i">
              <div :id="setSubItemWrapClass(i)" class="sub-item-wrap">
                <div
                  class="sub-item"
                  :id="setSubItemClass(i,j)"
                  @click="changeItemIndex(i,j)"
                  v-for="(sub,j) in item.subItem"
                  :key="j"
                >
                  <div class="wrap">
                    <div class="middle text" :id="setSubItemId(i,j)">{{sub.text}}</div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="section3" :key="itemkey">
        <div class="contain">
          <div class="title-wrap">
            <div class="title">{{menuItem.text}} > {{subItemItem.text}}</div>
          </div>
          <div class="wrap">
            <div class="item" v-for="(item ,i) in subItemItem.content" :key="i">
              <div v-if="item.videoUrl">
                <video
                  class="video"
                  id="video"
                  muted
                  loop="loop"
                  autoplay="autoplay"
                  controls="controls"
                  webkit-playsinline="true"
                  playsinline="true"
                >
                  <source :src="item.videoUrl" type="video/mp4" />
                </video>
                <div class="title">{{item.contentTitle}}</div>
                <div class="text" v-html="item.contentText"></div>
              </div>
              <div v-if="null==item.videoUrl">
                <img alt="xxx" :src="item.contentUrl" style="width: 100%;display:block;" />
                <div class="title">{{item.contentTitle}}</div>
                <div class="text" v-html="item.contentText"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { csvw_url } from "../../components/config";
import swiper from "../../components/swiper/classroom/swiper.vue";
import { data1 } from "./content/data";
import { getBrowserWidth } from "../../components/js/screen";
var startx, starty;

export default {
  name: "ClassroomMobile",
  components: {
    swiper,
  },
  data() {
    return {
      isTheme: true,
      navIndex: 0,
      menuData: data1, // 总的数据
      menu: [], // 按钮的数据,总的数据
      menuItem: {}, // 按钮的数据,每个一级页签的数据
      menuIndex: 0, // 一级菜单
      itemIndex: 0, // 二级菜单
      menuFlag: true, //点击一级菜单是否打开
      menuFlagIndex: 10, //点击一级菜单的index
      subItem: [], // 每个二级页签的数据
      subItemItem: {}, // 每个二级页签的数据的每一个数据
      itemkey: Date.now()
    };
  },
  mounted: function () {
    this.getData();
    // this.initData();
  },
  methods: {
    getData() {
      this.axios
        .get(`${csvw_url}/front/news/tcClassCover/list`)
        .then((response) => {
          this.menuData = response.data.data;
          this.addUrl();
          this.initData();
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    },
    addUrl() {
      for (let item of this.menuData) {
        item.coverUrl = `${csvw_url}${item.coverUrl}`;
        const menu = item.menu;
        for (let menu_item of menu) {
          menu_item.iconUrl = `${csvw_url}${menu_item.iconUrl}`;
          menu_item.iconSelect = `${csvw_url}${menu_item.iconSelect}`;
          const subItem = menu_item.subItem;
          for (let subItem_item of subItem) {
            const content = subItem_item.content;
            for (let content_item of content) {
              content_item.contentUrl = `${csvw_url}${content_item.contentUrl}`;
              if (
                null == content_item.videoUrl ||
                content_item.videoUrl == ""
              ) {
                content_item.videoUrl = null;
              } else {
                content_item.videoUrl = `${csvw_url}${content_item.videoUrl}`;
              }
            }
          }
        }
      }
    },
    initData() {
      this.menu = this.menuData[0].menu;
      this.menuItem = this.menu[0];
      this.subItem = this.menuItem.subItem;
      this.subItemItem = this.subItem[0];

      document.addEventListener(
        "touchstart",
        function (e) {
          startx = e.touches[0].pageX;
          starty = e.touches[0].pageY;
        },
        false
      );

      document.addEventListener("touchend", this.onTouchEnd, false);
    },
    changeNav(index) {
      document.removeEventListener("touchend", this.onTouchEnd, false);

      this.isTheme = false;
      this.navIndex = index;

      this.menu = this.menuData[index].menu;
      this.menuItem = this.menu[0];
      this.subItem = this.menuItem.subItem;
      this.subItemItem = this.subItem[0];
      this.itemkey = Date.now();
      this.menuFlagIndex = 10;

      setTimeout(() => {
        this.changeMenuIndex(0);
        this.changeItemIndex(0, 0);
        window.scrollTo(0, 0);
      }, 10);
    },
    setSubMenuClass(i) {
      let obj = `sub-menu${i}`;
      return obj;
    },
    changeMenuIndex(i) {
      if (this.menuIndex == i) {
        if (this.menuFlagIndex == this.menuIndex) {
          // 两次点击
          this.menuFlag = false;
          this.menuFlagIndex = 10;
          this.closeSubItem();
        } else {
          this.menuFlagIndex = this.menuIndex;
          this.menuFlag = true;
          this.openSubItem();
        }
      } else {
        this.menuFlagIndex = i;
        this.menuFlag = true;
      }

      this.menuIndex = i;

      this.clearMenu();
      document.getElementById(`sub-menu${i}`).style.background =
        "rgba(1, 1, 1, 0.7)";
      document.getElementById(`sub-menu-text${i}`).style.color =
        "rgba(255,255,255, 1)";
    },
    openSubItem() {
      let w = getBrowserWidth();
      let wid = 90;
      if (w <= 1300) {
        wid = 35;
      } else if (w > 1300 && w <= 1600) {
        wid = 42;
      } else if (w > 1600) {
        wid = 50;
      }
      document.getElementById(`sub-item-wrap${this.menuIndex}`).style.height =
        "";
    },
    closeSubItem() {
      document.getElementById(`sub-item-wrap${this.menuIndex}`).style.height =
        "0px";
    },
    clearMenu() {
      for (let index in this.menu) {
        if (this.menuIndex != index) {
          document.getElementById(`sub-menu${index}`).style.background = "";
          document.getElementById(`sub-menu-text${index}`).style.color =
            "rgba(0,0,0,1)";
        }
      }
    },
    setSubMenuId(i) {
      let obj = `sub-menu-text${i}`;
      return obj;
    },
    setSubItemWrapClass(i) {
      let obj = `sub-item-wrap${i}`;
      return obj;
    },
    setSubItemClass(i, j) {
      let obj = `sub-item${i}${j}`;
      return obj;
    },
    changeItemIndex(i, j) {
      this.menuIndex = i;
      this.itemIndex = j;

      this.menuItem = this.menu[i];
      this.subItem = this.menuItem.subItem;
      this.subItemItem = this.subItem[j];
      this.itemkey = Date.now();
      setTimeout(() => {
        this.clearItem();
        document.getElementById(`sub-item${i}${j}`).style.background =
          "rgba(1, 1, 1, 0.3)";
        document.getElementById(`sub-item-text${i}${j}`).style.color =
          "rgba(255,255,255, 1)";
      }, 10);
    },
    clearItem() {
      for (let index in this.menu) {
        let item = this.menu[index];
        let subItem = item.subItem;
        for (let subIndex in subItem) {
          if (this.menuIndex == index && this.itemIndex != subIndex) {
            document.getElementById(
              `sub-item${index}${subIndex}`
            ).style.background = "";
            document.getElementById(
              `sub-item-text${index}${subIndex}`
            ).style.color = "rgba(1, 1, 1, 1)";
          }
        }
      }
    },
    setSubItemId(i, j) {
      let obj = `sub-item-text${i}${j}`;
      return obj;
    },
    getAngle(angx, angy) {
      return (Math.atan2(angy, angx) * 180) / Math.PI;
    },
    getDirection(startx, starty, endx, endy) {
      var angx = endx - startx;
      var angy = endy - starty;
      var result = 0;

      //如果滑动距离太短
      if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
        return result;
      }

      var angle = this.getAngle(angx, angy);
      if (angle >= -135 && angle <= -45) {
        result = 1;
      } else if (angle > 45 && angle < 135) {
        result = 2;
      } else if (
        (angle >= 135 && angle <= 180) ||
        (angle >= -180 && angle < -135)
      ) {
        result = 3;
      } else if (angle >= -45 && angle <= 45) {
        result = 4;
      }
      return result;
    },
    onTouchEnd(e) {
      var endx, endy;
      endx = e.changedTouches[0].pageX;
      endy = e.changedTouches[0].pageY;
      var direction = this.getDirection(startx, starty, endx, endy);
      switch (direction) {
        case 0:
          break;
        case 1:
          break;
        case 2:
          break;
        case 3:
          break;
        case 4:
          break;
        default:
      }
    },
  },
};
</script>

<style scoped>
.clickStyle {
  cursor: pointer;
}
.section0 img {
  display: block;
}
.section1 {
  position: relative;
  margin-top: 20px;
}
.section1 .nav {
  display: -webkit-flex; /* Safari */
  display: flex;
  flex-direction: row;
  padding: 0px 10px;
}
.section1 .nav .item {
  margin: 0px 4px;
}

.section2 {
  position: relative;
  background: rgba(247, 247, 247, 1);
}
.section2 .contain {
  width: 100%;
  margin-top: 20px;
}
.section2 .sub-menu {
  position: relative;
  width: 100%;
  height: 30px;
}
.section2 .sub-menu .wrap {
  position: absolute;
  margin: auto;
  left: 15px;
  top: 0;
  bottom: 0;
  width: 320px;
  height: 30px;
}
.section2 .sub-menu .icon {
  position: relative;
  float: left;
  width: 23px;
  height: 100%;
}
.section2 .sub-menu .icon img {
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  height: 12px;
}
.section2 .sub-menu .middle {
  position: relative;
  float: left;
  margin-left: 0px;
  font-size: 14px;
  line-height: 30px;
  font-weight: bold;
}
.section2 .sub-menu .arrow {
  position: relative;
  float: right;
  width: 13px;
  height: 100%;
}
.section2 .sub-menu .arrow img {
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  height: 7px;
}

.section2 .sub-item-wrap {
  overflow: hidden;
}
.section2 .sub-item {
  position: relative;
  width: 100%;
  height: 30px;
}
.section2 .sub-item .wrap {
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 300px;
  height: 30px;
}
.section2 .sub-item .wrap .middle {
  margin-left: 0px;
  line-height: 30px;
  font-size: 12px;
}

.section3 {
  position: relative;
}
.section3 .contain {
  position: relative;
}
.section3 .contain .title-wrap {
  position: relative;
  height: 36px;
  border-bottom: solid 1px rgba(238, 238, 238, 1);
}
.section3 .contain .title-wrap .title {
  margin-left: 15px;
  height: 40px;
  font-size: 13px;
  line-height: 40px;
}
.section3 .contain .wrap {
  margin-top: 15px;
  padding: 0px 15px;
}
.section3 .contain .wrap .item {
  margin-bottom: 20px;
}
.section3 .contain .wrap .title {
  font-size: 13px;
  line-height: 20px;
  color: rgba(0, 0, 0, 1);
  margin-top: 10px;
}
.section3 .contain .wrap .text {
  font-size: 10px;
  line-height: 20px;
  color: rgba(0, 0, 0, 1);
  margin-top: 5px;
}
.section3 .contain .wrap .video {
  width: 100%;
}
</style>